// ---表示前処理----
import culIndex from './culIndex'
// チェック品詞の色の変更、空白文字の正常表示処理
const changeDocColor = function (argTargetIndex, argListSurf, isDark, ishiSpeed) {
  const tempSentence = argListSurf
  // tempSentence = blankProcess(tempSentence)
  let beginTag = ''
  let closeTag = ''
  if (ishiSpeed === false) {
    beginTag = (isDark) ? '<span style="background-color: #0000CC;">' : '<span style="background-color: #CCFFCC;">'
    closeTag = '</span>'
  }
  // 連続リストを用いて該当部分の連続単語を作成
  argTargetIndex.map(function (value, index, array) {
    tempSentence[value] = beginTag + tempSentence[value] + closeTag
  })
  return tempSentence.join('')
}

// const blankProcess = function (argListSurf) {
//   argListSurf = argListSurf.map((value) => {
//     // 空白(3000)を見つけたらspanで囲む
//     return String(value).codePointAt(0).toString(16) === ('3000' || 'ff00') ? '<span style="position:relative"></span>' : value
//   })
//   return argListSurf
// }

// 品詞の文字列抽出処理
const getSinglePosDocList = function (argTargetIndex, argListSurf, argIsCount) {
  let posDocList = []
  for (const pick of argTargetIndex) {
    posDocList = posDocList.concat(argListSurf[pick])
  }
  if (argIsCount === true) {
    // return Object.entries(countList(posDocList)).map(([key, value]) => (value + '：' + key)).map((pic) => { return pic.replace(/<br>/g, '') }).sort().filter(v => v)
    return Object.entries(countList(posDocList))
    .map(([key, value]) => ({ count: parseInt(value, 10), key }))
    .sort((a, b) => {
      // 出現回数が同じ場合は、key自体でソート
      if (a.count === b.count) {
        return a.key > b.key ? 1 : -1
      }
      // 出現回数で降順ソート
      return a.count - b.count
    })
    .map(({ count, key }) => `${count}：${key}`)
    .filter(v => v)
  } else {
    // 重複排除後、改行と空要素除の削除した後表示
    return culIndex.deduplicate(posDocList).sort().filter(v => v)
  }
}
// 連続品詞の表示処理
const getContPosDocList = function (argTargetIndex, argListSurf, argIsCount) {
  const sequenceList = []
  let temp = ''
  // 連続した形態素の文章を結合し、配列に格納する
  culIndex.getContinuumList(argTargetIndex).map(function (value, index, array) {
    if (array.includes(value + 1) === false) {
      temp = temp + argListSurf[value]
      sequenceList.push(temp)
      temp = ''
    } else { temp = temp + argListSurf[value] }
  })
  // カウンタ付きの一覧に変換。重複排除後、改行と空要素除の削除した後表示
  if (argIsCount === true) {
    // return Object.entries(countList(sequenceList)).map(([key, value]) => (value + '：' + key)).sort().filter(v => v)
    return Object.entries(countList(sequenceList))
      .map(([key, value]) => ({ count: parseInt(value, 10), key }))
      .sort((a, b) => {
        // 出現回数が同じ場合は、key自体でソート
        if (a.count === b.count) {
          return a.key > b.key ? 1 : -1
        }
        // 出現回数で降順ソート
        return a.count - b.count
      })
      .map(({ count, key }) => `${count}：${key}`)
      .filter(v => v)
  } else {
    // そのまま。重複排除後、改行と空要素除の削除した後表示
    return culIndex.deduplicate(sequenceList).sort().filter(v => v)
  }
}
// リスト中の要素をカウントしたオブジェクトを返す。
function countList (argCurrentArray) {
  var counts = {}
  for (let i = 0; i < argCurrentArray.length; i++) {
    counts[argCurrentArray[i]] = (counts[argCurrentArray[i]]) ? counts[argCurrentArray[i]] + 1 : 1
  }
  return counts
}
export default {
  changeDocColor,
  // blankProcess,
  getSinglePosDocList,
  getContPosDocList,
}
